module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/submission/components/upload-dialog.component.scss
// module id = ./src/app/submission/components/upload-dialog.component.scss
// module chunks = main